<template>
  <InvoiceParameterLabel :headerForm="true">
    <slot></slot>
  </InvoiceParameterLabel>
</template>
<script>
import InvoiceParameterLabel from './InvoiceParameterLabel.vue';
export default {
  name: "InvoiceParameterHeader",
  components: {
    InvoiceParameterLabel,
  }
}
</script>